export const initPreFooterGrow = () => {
   const prefooterInner = document.querySelector('.pre-footer__inner');
   const toggleButton = document.querySelector('.pre-footer__toggle-button');
   const buttonIcon = document.querySelector('.pre-footer__toggle-button-icon');

   if (!prefooterInner || !toggleButton) return;

   toggleButton.addEventListener('click', () => {
      const currentHeight = prefooterInner.style.height;

      if (currentHeight > '0px') {
         const fullHeight = prefooterInner.scrollHeight;

         prefooterInner.style.height = fullHeight + 'px';
         requestAnimationFrame(() => {
            prefooterInner.style.height = '0px';
            buttonIcon.style.transform = 'rotate(-90deg)';
         });
      } else {
         const fullHeight = prefooterInner.scrollHeight;

         prefooterInner.style.height = fullHeight + 'px';
         buttonIcon.style.transform = 'rotate(90deg)';
      }
   });
};